// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JH8k","col":"styles_col__3eSCz"};